import { useEffect } from 'react';
import { useAppDispatch } from '../../../store/app.hooks';
import React from 'react';
import GlobalSearch from '../../../common/components/globalSearch/GlobalSearch';
import { useHistory, useParams } from 'react-router-dom';
import { IExcelColumnMappingProps } from './excelColumnMapping.model';
import { clearExcelColumnMapping } from '../../../store/master/excelColumnMapping/excelColumnMapping.reducer';
import MainTable from './MainTable';
import { Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import { Button } from 'antd';

const ExcelColumnMapping: React.FC<IExcelColumnMappingProps> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { id: urlId } = useParams<{ id?: string }>();

  useEffect(() => {
    return () => {
      dispatch(clearExcelColumnMapping());
    };
  }, []);

  return (
    <div className="ad">
      <div className="title-block">
        <h4 className="p-0">
          <BreadCrumbs pageName={Page.ExcelColumnMapping} />
        </h4>
        <div className="right-title">
          <GlobalSearch />
        </div>
        <div className="btns-block">
          <Button
            className="btn-icon"
            type="primary"
            onClick={() => history.goBack()}
            icon={
              <em className="anticon">
                <img src={`${process.env.PUBLIC_URL}/assets/images/ic-left-arrow.svg`} alt="" />
              </em>
            }
          >
            Back
          </Button>
        </div>
      </div>
      <div className="main-card">
        <MainTable id={+urlId} />
      </div>
    </div>
  );
};

export default ExcelColumnMapping;
